var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root-metaverse-section"},[_c('with-background-image-partial',{staticClass:"metaverse-section",attrs:{"title":_vm.i18nSection('launchpadMetaverseTitle'),"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }